import { render, staticRenderFns } from "./sub_head.vue?vue&type=template&id=f36aecca&scoped=true"
import script from "./sub_head.vue?vue&type=script&lang=js"
export * from "./sub_head.vue?vue&type=script&lang=js"
import style0 from "./sub_head.vue?vue&type=style&index=0&id=f36aecca&prod&lang=css"
import style1 from "./sub_head.vue?vue&type=style&index=1&id=f36aecca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36aecca",
  null
  
)

export default component.exports